var map = {
	"./blocklistUrlInfoPopover.pug": 3278,
	"./whitelistFullDataInfoPopover.pug": 3279,
	"./whitelistUrlInfoPopover.pug": 3280,
	"./whitelistUserPromptsInfoPopover.pug": 3281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3277;